export default Object.freeze({
  HOME: {
    name: 'Home',
    path: '/home',
  },
  PRODUCTS: {
    name: 'Products',
    path: '/shop',
    exact: true,
  },
  PRODUCT_DETAILS: {
    name: 'Product Details',
    path: '/shop/:slug',
    exact: true,
  },
  ERROR: {
    name: 'Error',
    path: '/error',
  },
  SUBMIT_REVIEW: {
    name: 'Submit Review',
    path: '/review/:slug',
    pathName: '/review',
    exact: true,
    protected: true,
  },
  EDIT_REVIEW: {
    name: 'Edit Review',
    path: '/review/:slug/edit/:reviewId',
    pathName: '/review',
    exact: true,
    protected: true,
  },
  CART: {
    name: 'Cart',
    path: '/cart',
    protected: true,
  },
  CHECKOUT: {
    name: 'Checkout',
    path: '/checkout',
    protected: true,
  },
  PAYMENT: {
    name: 'Payment',
    path: '/payment',
    protected: true,
  },
  ORDER_SUCCESS: {
    name: 'Order Success',
    path: '/order-success/:id',
    pathName: '/order-success',
    protected: true,
  },
  AUTH: {
    name: 'Auth',
    path: '/auth',
    protected: false,
    subRoutes: {
      REGISTRATION: {
        name: 'Registration',
        path: '/auth/registration',
      },
      LOGIN: {
        name: 'Login',
        path: '/auth/login',
      },
    },
  },
  ACCOUNT: {
    name: 'Account',
    path: '/account',
    protected: true,
    subRoutes: {
      PROFILE: {
        name: 'Profile',
        path: '/account/profile',
      },
      ADDRESSES: {
        name: 'Addresses',
        path: '/account/addresses',
      },
      BUSINESS_INFO: {
        name: 'Business Information',
        path: '/account/business-info',
      },
      MANAGE_ORDERS: {
        name: 'Manage orders',
        path: '/account/manage-orders',
        exact: true,
      },
      WISHLIST: {
        name: 'Wishlist',
        path: '/account/wishlist',
        exact: true,
      },
      ORDER_DETAILS: {
        name: 'Manage orders',
        path: '/account/manage-orders/:orderId',
        exact: true,
      },
      MY_REVIEWS: {
        name: 'My Reviews',
        path: '/account/reviews',
      },
    },
  },
});
